import "../styles/Legal.scss";

function ContactUs() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Contact Us</h1>

        <section>
          <p>Reach out for order support, product questions, or delivery help.</p>

          <address>
            <strong>FoodExpress</strong><br />
            Email: contact@foodexpress@gmail.com<br />
            Phone: +91 8777370341 / 7013608102<br />
            India
          </address>
        </section>
      </div>
    </div>
  );
}

export default ContactUs;
